import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '../../common/Response';

@Injectable({
  providedIn: 'root'
})
export class EmopPublicWorkflowApprovalApiService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * 审批
   * @param taskId 
   * @param payload 
   * @returns 
   */
  getProcessInstanceDetail(processInstanceId: string) {
    return this.http.get<Response<any>>('/workflow/v1/history/process-instance', {
      params: {
        processInstanceId
      }
    });
  }
  /**
   * 审批
   * @param taskId 
   * @param payload 
   * @returns 
   */
  approvalFlow(taskId: string, payload: string) {
    return this.http.post<Response<any>>('/workflow/process/engine/flow',
      {
        payload
      },
      {
        params: {
          taskId,
        }
      }
    );
  }
  /**
   * 获取审批对象
   * @param taskId 
   * @param payload 
   * @returns 
   */
  getApprovalObject(processInstanceId: string) {
    return this.http.get<Response<any>>(`/workflow/v1/process-instance/${processInstanceId}/startTaskPayload`);
  }
  /**
   * 获取审批记录
   */
  getTaskDetail(processInstanceId: string) {
    return this.http.get<Response<any>>(`/workflow/v1/history/task`, {
      params: {
        processInstanceId
      }
    });
  }
  /**
   * 获取流程图Canvas数据
   * @param processInstanceId 
   * @returns 
   */
  processInstanceTrace(processInstanceId: string) {
    return this.http.get<Response<any>>(`/workflow/v1/process-instance/${processInstanceId}/trace`);
  }
  /**
   * 
   * @param processInstanceId 流程id
   * @returns 
   */
  getXml(processInstanceId: string) {
    return this.http.get<Response<string>>(`/workflow/v1/process-instance/${processInstanceId}/xml`);
  }
  /**
   * 
   * @param id 流程中任务的id
   * @returns 
   */
  getJsonSchema(id: string) {
    return this.http.get<Response<string>>(`/workflow/v1/task/${id}/jsonSchema`);
  }
  /**
   * 获取当前节点
   * @param processInstanceId 
   * @param assignee 
   * @returns 
   */
  firstTask(processInstanceId: string, assignee: string) {
    return this.http.post<Response<any>>('/workflow/v1/task/first', {
      processInstanceId,
      assignee
    });
  }
}
